import "./EmptySection.css";
import { BarChart as BarChartIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

export default function EmptySection({ icon, text, className }) {
  return (
    <div className={["EmptySection", className].filter(Boolean).join(" ")}>
      {icon}
      <span>{text}</span>
    </div>
  );
}

export function EmptyGraph() {
  const { t } = useTranslation(["common"]);
  return (
    <div
      style={{
        padding: "1rem",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <EmptySection text={t("common:noData")} icon={<BarChartIcon />} />
    </div>
  );
}
